import Image from 'next/image';
import { Button } from '@/features/button';
import { AppButton } from '@/features/product-card/app-button';
import { getCdnUrl } from '@/utils/url';
import { useVideosFilterContext } from '../context';
const NoResultImage = getCdnUrl('/_toad/images/no-video.svg');
const NoResult = () => {
  const {
    clearAllFilters
  } = useVideosFilterContext();
  return <div className='flex grow flex-col items-center justify-center gap-4 pb-19' data-sentry-component="NoResult" data-sentry-source-file="no-result.tsx">
            <Image src={NoResultImage} width={250} height={200} unoptimized alt='تصویر جست‌وجوی بدون نتیجه' data-sentry-element="Image" data-sentry-source-file="no-result.tsx" />

            <p className='text-body-14 text-text-darkGray lg:text-body-16'>
                ویدئویی با فیلترهایی که انتخاب کرده‌اید یافته نشد!
            </p>

            <Button size='large' graphicStyle='text' onClick={clearAllFilters} className='hidden lg:block' data-sentry-element="Button" data-sentry-source-file="no-result.tsx">
                حذف فیلترها
            </Button>

            <AppButton className='absolute bottom-12 w-screen lg:bottom-0' isSingleButton data-sentry-element="AppButton" data-sentry-source-file="no-result.tsx">
                <Button size='large' graphicStyle='outlined' className='w-full' onClick={clearAllFilters} data-sentry-element="Button" data-sentry-source-file="no-result.tsx">
                    حذف فیلترها
                </Button>
            </AppButton>
        </div>;
};
export default NoResult;